@if (nextScheduledEftersynCreation) {
  <p class="no-margin-top orange">
    Næste planlagte eftersyn:
    <strong>kl. {{ nextScheduledEftersynCreation | date : 'shortTime' }}</strong>
  </p>
}
<div class="flex-wrap flex-wrap--flex-start margin-bottom-x2">
  <div class="flex-wrap__col flex-wrap__col--40">
    <h2>Seneste oprettede eftersyn</h2>
    @if (recentEftersynLoading$ | async) {
      <div class="flex align-center">
        <div class="loading loading--dark"></div>
      </div>
    }
    <table mat-table [dataSource]="recentEftersyn">
      <ng-container matColumnDef="timestamp">
        <th mat-header-cell *matHeaderCellDef>Dato</th>
        <td mat-cell *matCellDef="let eftersyn">{{ eftersyn.oprettid | date : 'short' }}</td>
      </ng-container>

      <ng-container matColumnDef="oKAftaleNr">
        <th mat-header-cell *matHeaderCellDef>Aftalenr.</th>
        <td mat-cell *matCellDef="let eftersyn">{{ eftersyn.okKundeAftalenr }}</td>
      </ng-container>

      <ng-container matColumnDef="ordreNo">
        <th mat-header-cell *matHeaderCellDef>Ordrenr.</th>
        <td mat-cell *matCellDef="let eftersyn">{{ eftersyn.serviceordreNo }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsEftersyn"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsEftersyn"></tr>
    </table>
  </div>
  <div class="flex-wrap__col flex-wrap__col--60">
    <h2>Lægges på kø ved næste opkrævning</h2>
    <mat-tab-group [color]="'accent'">
      <mat-tab label="Eftersyn: {{ waitingEftersynCreatedTotal }}">
        @if (waitingEftersynCreatedLoading$ | async) {
          <div class="flex align-center">
            <div class="loading loading--dark"></div>
          </div>
        }
        <table mat-table [dataSource]="waitingEftersynCreated">
          <ng-container matColumnDef="oKAftaleNr">
            <th mat-header-cell *matHeaderCellDef>Dato</th>
            <td mat-cell *matCellDef="let customerOpkraevning">{{ customerOpkraevning.naesteEftersynDate | date : 'short' }}</td>
          </ng-container>
          <ng-container matColumnDef="timestamp">
            <th mat-header-cell *matHeaderCellDef>Aftalenr.</th>
            <td mat-cell *matCellDef="let customerOpkraevning">{{ customerOpkraevning.okKundeAftalenr }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsAftaleQueue"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsAftaleQueue"></tr>
        </table>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
